import Main from './js/Main';

export default Main;
